var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.851 11.923C14.672 11.282 14.33 10.677 13.826 10.174C12.264 8.612 9.731 8.611 8.169 10.174L3.171 15.172C1.609 16.735 1.608 19.267 3.171 20.829C4.733 22.392 7.267 22.39 8.827 20.829L12.669 16.988L13.002 16.997C13.406 16.997 13.804 16.957 14.191 16.88L9.534 21.536C8.559 22.512 7.279 23 5.999 23C4.719 23 3.439 22.512 2.464 21.536C0.512 19.585 0.512 16.416 2.464 14.465L7.462 9.467C8.437 8.491 9.718 8.003 10.998 8.003C12.277 8.003 13.558 8.491 14.533 9.467C15.026 9.96 15.394 10.53 15.638 11.139L14.851 11.923ZM9.148 12.07C9.326 12.713 9.669 13.32 10.174 13.826C11.736 15.389 14.27 15.387 15.83 13.826L20.829 8.828C22.392 7.266 22.392 4.733 20.829 3.171C19.267 1.609 16.734 1.608 15.172 3.171L11.331 7.012L10.998 7.003C10.594 7.003 10.196 7.043 9.809 7.12L14.465 2.464C15.44 1.488 16.721 1 18.001 1C19.28 1 20.561 1.488 21.536 2.464C23.487 4.415 23.487 7.583 21.536 9.535L16.537 14.533C15.562 15.509 14.282 15.997 13.002 15.997C11.722 15.997 10.442 15.509 9.467 14.533C8.973 14.038 8.604 13.466 8.36 12.855L9.148 12.07Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkWhite);
export default __webpack_public_path__ + "static/media/linkWhite.f49f89d12cbbd975f74d199fab9183b8.svg";
export { ForwardRef as ReactComponent };